<template>
  <vue3-chart-js v-bind="{ ...lineChart }" />
</template>

<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import zoomPlugin from "chartjs-plugin-zoom";
import dataLabels from "chartjs-plugin-datalabels";

// globally registered and available for all charts
Vue3ChartJs.registerGlobalPlugins([zoomPlugin]);

export default {
  name: "App",
  components: {
    Vue3ChartJs,
  },
  props: {
    data_input : [],
    data_labels : [],
    data_type: ""
  },
  setup(props) {
    let delayed;
    let label_display = true;
    let y_axis_labels = [];

    let labels = props.data_labels;
    labels = ['0'].concat(labels);

    let data = props.data_input;
    data = ['0'].concat(data);

    if(props.data_input.length < 1){
      label_display = false
    }
    const lineChart = {
      type: "line",
      props: {
        data_input: [],
        data_labels: [],
        data_type: "",
      },
      data: {
        labels: labels ? labels : '',
        datasets: [
          {
            label: props.data_type.charAt(0).toUpperCase() + props.data_type.slice(1).replace("_", " "),
            data: data,
            fill: true,
            tension: 0,
            padding: 5,
            pointRadius: 4,
            pointBackgroundColor: "#030c26",
            borderColor: "#030c26",
            backgroundColor: "rgba(148, 236, 227, 0.3)",
            fillColor: gradientColor("#94ECE3", "#77c8ba"),
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          x: {
            display: label_display,
            ticks: {
              color: "#030c26",
            },
            grid: {
              display: false,
            },
            title: {
              display: true,
              color: "#bbb",
              text: 'Transaction Date',
              padding: {
                top: 15, // Adjust the top padding as needed
              },
            }
          },
          y: {
            display: label_display,
            ticks: {
              color: "#030c26",
              beginAtZero: true,
              min: 0,
              callback: (value) => {
                if (props.data_type === 'sales' || props.data_type === 'clicks') {
                  const intValue = parseInt(value);
                  if (!y_axis_labels.includes(intValue)) {
                    y_axis_labels.push(intValue);
                  }
                  return intValue === y_axis_labels[y_axis_labels.length - 1] ? intValue : '';
                } else {
                  return '$' + value.toFixed(2);
                }
              }
            },
            grid: {
              display: true,
              color: "rgba(133, 212, 204, 0.9)",
            },
            border: {
              dash: [2,4],
            },
            gridLines: {
              drawBorder: false,
            },
          },
        },
        animation: {
          onComplete: () => {
            delayed = true;
          },
          delay: (context) => {
            let delay = 1100;
            return delay;
          },
        },
        plugins: {
          datalabels: {
            backgroundColor: function (context) {
              //return context.dataset.backgroundColor;
            },
            font: {
              // weight: "bold",
            },
            padding: 10,
          },
          legend: {
            display: false,
          },
        },
      },
    };

    // Function to generate a gradient color
    function gradientColor(startColor, endColor) {
      const ctx = document.createElement("canvas").getContext("2d");
      const gradient = ctx.createLinearGradient(0, 0, 0, 400); // Adjusted the parameters here
      gradient.addColorStop(0, startColor);
      gradient.addColorStop(1, endColor);
      return gradient;
    }


    return {
      lineChart,
    };
  },
};
</script>

<style lang="scss">
.performance-graph{
  width: 100%;
  margin-top: 1.5rem;
  &.empty{
    position: relative;
    &:after{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image:url(../assets/placeholder.png);
      background-size: cover;
      background-color: rgba(255,255,255,0.3);
      content:"No real data to show, check back later.";
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      color: #ccc;
    }
  }
  canvas {
    width: 100%!important;
    height: auto!important;
  }
}
</style>
